import { createSlice } from "@reduxjs/toolkit";
import GnlKullanicivarsayilanDTO from "src/models/Genel/GnlKullanicivarsayilanDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { GnlKullaniciVarsayilanApi } from "src/services/Base/GnlKullaniciVarsayilanApi";

interface IGnlKulVarsayilanState {
  data: Array<GnlKullanicivarsayilanDTO>
}
const GnlKullaniciVarsayilanSlice = createSlice<IGnlKulVarsayilanState, MapReducerPayloads<IGnlKulVarsayilanState, {
}>>({
  name: 'gnlkullanicivarsayilan',
  initialState: {
    data: []
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addMatcher(GnlKullaniciVarsayilanApi.endpoints.getKullaniciVarsayilanList.matchFulfilled, (state, action) => {
      return {
        ...state,
        data: action.payload
      };
    })
  }
})
export default GnlKullaniciVarsayilanSlice;